<div class="h-100 h-100-h d-flex flex-column" [@homeSlide]="prepareRoute(o)">
  <div class="h-100 min-h-0">
    <app-header [homeHeader]="homeHeader" [locationUrl]="locationUrl" [ngClass]="homeHeader ? 'header-home' : ''"></app-header>
    <!--<div class="h-100" [@homeSlide]="prepareRoute(o)">-->
    <router-outlet #o="outlet"></router-outlet>
    <!--</div>-->
  </div>
</div>
